var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/sms-tracking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-tracking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 15.9375H5.25C4.9425 15.9375 4.6875 15.6825 4.6875 15.375C4.6875 15.0675 4.9425 14.8125 5.25 14.8125H12.75C14.895 14.8125 15.9375 13.77 15.9375 11.625V6.375C15.9375 4.23 14.895 3.1875 12.75 3.1875H5.25C3.105 3.1875 2.0625 4.23 2.0625 6.375C2.0625 6.6825 1.8075 6.9375 1.5 6.9375C1.1925 6.9375 0.9375 6.6825 0.9375 6.375C0.9375 3.6375 2.5125 2.0625 5.25 2.0625H12.75C15.4875 2.0625 17.0625 3.6375 17.0625 6.375V11.625C17.0625 14.3625 15.4875 15.9375 12.75 15.9375Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00008 9.65296C8.37008 9.65296 7.73258 9.45797 7.24508 9.06047L4.89758 7.18547C4.65758 6.99047 4.61258 6.63796 4.80758 6.39796C5.00258 6.15796 5.35507 6.11297 5.59507 6.30797L7.94257 8.18297C8.51257 8.64047 9.48007 8.64047 10.0501 8.18297L12.3976 6.30797C12.6376 6.11297 12.9976 6.15046 13.1851 6.39796C13.3801 6.63796 13.3426 6.99797 13.0951 7.18547L10.7476 9.06047C10.2676 9.45797 9.63008 9.65296 9.00008 9.65296Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6 12.9375H1.5C1.1925 12.9375 0.9375 12.6825 0.9375 12.375C0.9375 12.0675 1.1925 11.8125 1.5 11.8125H6C6.3075 11.8125 6.5625 12.0675 6.5625 12.375C6.5625 12.6825 6.3075 12.9375 6 12.9375Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.75 9.9375H1.5C1.1925 9.9375 0.9375 9.6825 0.9375 9.375C0.9375 9.0675 1.1925 8.8125 1.5 8.8125H3.75C4.0575 8.8125 4.3125 9.0675 4.3125 9.375C4.3125 9.6825 4.0575 9.9375 3.75 9.9375Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsCheck);
export default __webpack_public_path__ + "static/media/sms_check.27af8a5040987d5343ce3e0fbc7ea3f0.svg";
export { ForwardRef as ReactComponent };